'use client';
import { ChevronRight } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import { memo } from 'react';
import { components } from '@/types/strapi';

// Menu Item Component with Icons
const MenuItemComponent = ({
	item,
}: {
	item: components['schemas']['ItemsSubmenuItemComponent'];
}) => {
	// const colors = {
	// 	blue: {
	// 		border: 'border-blue-100',
	// 		hover: 'hover:border-blue-200 hover:bg-blue-50',
	// 		text: 'group-hover:text-blue-600',
	// 		gradient: 'from-blue-50/50',
	// 	},
	// const scheme = colors[colorScheme];

	return (
		<Link
			href={item.href || '#'}
			className={`group mb-1 block rounded-lg border border-gray-100 bg-white p-2.5 transition-all hover:border-blue-200 hover:bg-blue-50 hover:shadow-sm`}>
			<div className="flex items-center justify-between gap-2">
				<div className="min-w-0 flex-1">
					<div className="flex items-center gap-2">
						{item.icon && item.icon.url && (
							<div className="flex-shrink-0">
								<Image
									src={item.icon.url}
									alt={item.icon.name || 'Icon'}
									width={15}
									height={15}
									className="mt-0.6 h-4 w-4 text-blue-500"
								/>
							</div>
						)}
						<div>
							<span className="text-sm text-gray-900 group-hover:text-blue-600">
								{item.name}
							</span>
						</div>
					</div>
				</div>
				<div className="ml-2 shrink-0 text-gray-400 group-hover:text-gray-600">
					<ChevronRight className="h-4 w-4" />
				</div>
			</div>
		</Link>
	);
};

// Category Component that handles a group of items
const CategoryComponent = memo(function CategoryComponent({
	category,
}: {
	category: components['schemas']['ItemsSubmenuContentComponent'];
}) {
	return (
		<div>
			<h4 className="mb-1 text-sm font-medium text-gray-900">
				{category.category}
			</h4>
			{category.submenu_items?.map((subItem, index) => (
				<MenuItemComponent key={index} item={subItem} />
			))}
			{/* {!category.submenu?.length && category.href && (
				<MenuItemComponent
					item={category}
					isHighlighted={true}
					colorScheme={colorScheme}
					icon={getIconForItem(category.name)}
				/>
			)} */}
		</div>
	);
});

/**
 * Product specialized menu - optimized for product showcase
 */
export default function ProductMenu({
	item,
	name,
	icon,
}: {
	item: components['schemas']['ItemsSubmenuContentComponent'][];
	name: string;
	icon: components['schemas']['GlobalMegamenuComponent']['icon'];
}) {
	console.log(item);
	return (
		<div className="menu-content-wrapper w-full">
			<div className="w-full rounded-lg border border-gray-100 bg-white/95 p-2.5 shadow-lg">
				<div className="mb-2 flex items-center justify-between border-b pb-1.5">
					<div className="flex items-center gap-2">
						{icon && icon.url && (
							<Image
								src={icon.url}
								alt={icon.name || 'Icon'}
								width={20}
								height={20}
								className="h-5 w-5 text-blue-500"
							/>
						)}
						<h3 className="text-base font-semibold text-gray-900">
							{name}
						</h3>
					</div>
				</div>
				{item.length > 0 && (
					<div
						className={`grid grid-cols-${item.length === 1 ? 1 : Math.min(item.length, 4)} gap-2`}>
						{item?.map(
							(
								values: components['schemas']['ItemsSubmenuContentComponent'],
								ind: number,
							) => (
								<div key={ind} className="col-span-auto">
									<CategoryComponent category={values} />
								</div>
							),
						)}
					</div>
				)}
			</div>
		</div>
	);
}
